import React from "react";
import { useUserCurrency } from "../../hooks/useUserCurrency";
import { currencySymbols } from "../../utils/currency";

const CurrencyStatusIndicator = ({ userId, className = "" }) => {
  const { getCurrencyStatus, loading, error, isLoaded } =
    useUserCurrency(userId);

  if (!isLoaded || loading) {
    return (
      <div className={`bg-gray-100 rounded-lg p-3 ${className}`}>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-3 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={`bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 ${className}`}
      >
        <div className="flex items-center gap-2">
          <span className="text-lg">⚠️</span>
          <div>
            <p className="font-medium text-sm">Error Loading Currency</p>
            <p className="text-xs opacity-75">Using USD fallback</p>
          </div>
        </div>
      </div>
    );
  }

  const statusInfo = getCurrencyStatus();
  const symbol = currencySymbols[statusInfo.currency] || "";

  const colorClasses = {
    blue: "bg-blue-50 border-blue-200 text-blue-700",
    green: "bg-green-50 border-green-200 text-green-700",
    gray: "bg-gray-50 border-gray-200 text-gray-700",
  };

  return (
    <div
      className={`rounded-lg border p-3 ${
        colorClasses[statusInfo.color]
      } ${className}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-lg">{statusInfo.icon}</span>
          <div>
            <p className="font-medium text-sm">
              {symbol} {statusInfo.currency}
            </p>
            <p className="text-xs opacity-75">{statusInfo.label}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyStatusIndicator;
